<template>
  <!-- APP版本管理 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor glo_bgcMainColor" @click="addServe()"
          >新建</el-button
        >
        <!-- <el-button class="itemBtn btnColor" @click="DelServe()">删除</el-button> -->
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="false"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItems" label="版本号:">
          <el-input
            clearable
            v-model="queryData.number"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="创建人:">
          <el-input
            clearable
            v-model="queryData.createUserName"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        ref="mytable"
        :data="tableData"
        :height="tableHeigth"
        highlight-current-row
        @row-click="rowclick"
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column fixed="left" type="selection" width="60">
        </el-table-column>

        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            v-if="item.field == 'isForceShow'"
            :key="index"
            :label="item.name"
            sortable
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isForce == 0" style="color: #f00">
                {{ scope.row.isForceShow }}
              </div>
              <div v-else>{{ scope.row.isForceShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="item.field == 'fileUrl'"
            :key="index"
            :label="item.name"
            sortable
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div
                class="colorBlue clickDownLoad"
                @click="clickDownLoadAPP(scope.row.fileUrl)"
              >
                {{ scope.row.fileUrl }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            sortable
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="140px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="editorServe(scope.row)"
                >编辑</el-button
              >
              <el-button class="rbtns" @click.stop="DelServe(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtns('diaConfirmBtns')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="diaConfirmBtns"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="number" label="版本号:">
            <el-input v-model="dialogForm.number"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="versionName"
            label="版本名称:"
            placeholder="请输入"
          >
            <el-input v-model="dialogForm.versionName"></el-input>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="deviceType"
            label="设备类型:"
            placeholder="请输入"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.deviceType"
              placeholder="请选择"
            >
              <el-option
                v-for="item_a in deviceTypeList"
                :key="item_a.val"
                :label="item_a.showName"
                :value="item_a.statusVal"
              ></el-option>
            </el-select>
            <!-- <el-input disabled v-model="dialogForm.deviceType"></el-input> -->
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="isForce"
            label="是否强制升级:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm.isForce"
              placeholder="请选择"
            >
              <el-option
                v-for="item_a in yesOrNoList"
                :key="item_a.val"
                :label="item_a.name"
                :value="item_a.val"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="remark" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remark"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="" label="上传文件:" v-if="dialogType == 'add'">
            <el-upload
              class="upload-demo"
              drag
              :action="upLoadUrl"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
                只能上传jpg/png文件，且不超过500kb
              </div> -->
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>

<script>
// import { apiList, this.$API } from "@/assets/js/api";
// import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import { showLoading, hideLoading } from "@/assets/js/common/loading";
export default {
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    uploadimgs,
  },
  data() {
    return {
      fileList: [],
      yesOrNoList: [
        {
          name: "是",
          val: 1,
        },
        {
          name: "否",
          val: 0,
        },
      ],
      fileLists: [],
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableData: [], //表格数据
      tableHeigth: "75vh",
      selectTableData: [],

      queryData: { number: "", createUserName: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogForm: {
        deviceType: "android:device_type",
        fileId: "",
        isForce: 0,
        number: "",
        versionName: "",
        remark: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      upLoadUrl: this.$COMMON.uploadUrl,
      fileNameLists: [],
      myTableHeard: [
        {
          name: "版本号",
          field: "number",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "版本名称",
          field: "versionName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "设备类型",
          field: "deviceTypeShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "下载地址",
          field: "fileUrl",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "200",
        },
        {
          name: "更新内容描述",
          field: "remark",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "是否强制升级",
          field: "isForceShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "110",
        },
        {
          name: "创建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
          width: "160",
        },
      ],
      dialogType: "add",
      deviceTypeList: [],
      isupLoad: false,
    };
  },
  updated() {},
  created() {},
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    clickDownLoadAPP(url) {
      let downloadurl = url;
      //下载(这里其实是直接访问)
      var a = document.createElement("a");
      a.setAttribute("href", downloadurl);
      a.setAttribute("target", "_blank");
      a.download = "";
      a.click();
    },

    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData(); //  根据后台需求数据格式
      form.append("file", file); //  文件对象
      form.append("fileName", fileName); //  本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      let sign = this.$TOOLS.getSign({ fileName: fileName });
      form.append("sign", sign);

      showLoading();
      this.isupLoad = true;

      this.$API
        .uploadFile(form)
        .then((res) => {
          hideLoading();
          this.isupLoad = false;
          //   this.fileNameList.push(res.data.result.fileName);
          let obj = {
            name: res.data.result.fileName,
            url: res.data.result.url,
          };
          this.fileLists.push(obj);
          // this.changeFileList(this.fileLists);
        })
        .catch(() => {
          this.isupLoad = false;
        });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 删除
    DelServe(row) {
      let ids = [];
      if (row) {
        ids.push(row.versionId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message({
            message: "请至少勾选一条数据",
            type: "warning",
          });
          return false;
        }

        this.selectTableData.forEach((item) => {
          ids.push(item.versionId);
        });
      }

      let param = {
        versionIds: ids,
      };

      this.$confirm("该操作将永久删除该文件,请谨慎操作!", "提示:")
        .then((res) => {
          this.$API.delAppVersion(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    getdeviceType() {
      this.$TOOLS.getStatusValList("app_version_v3.device_type").then((res) => {
        this.deviceTypeList = res || [];
      });
    },
    // 新建版本
    addServe() {
      this.dialogTitle = "新建版本";
      this.dialogType = "add";
      this.isShowDialog = true;
      this.getdeviceType();
    },
    // 编辑
    editorServe(row) {
      this.dialogTitle = "修改版本";
      this.dialogType = "edit";
      this.dialogForm = row;
      this.isShowDialog = true;
      this.getdeviceType();
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let param = {
        createUserName: this.queryData.createUserName,
        number: this.queryData.number,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getAppVersionList(param).then((res) => {
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.fileLists = [];
      this.fileList = [];
      this.dialogForm = {
        deviceType: "android:device_type",
        fileId: "",
        isForce: 0,
        number: "",
        versionName: "",
        remark: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtns(formName) {
      if (this.isupLoad) {
        this.$message.error("正在上传app安装包,请稍后再试");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fileIds = "";

          if (this.dialogType == "add") {
            if (this.fileLists.length == 0) {
              this.$message.error("请上传APP的安装包");
              return false;
            } else {
              fileIds = this.fileLists[0].name;
            }
          }
          if (this.dialogType == "edit") {
            fileIds = this.dialogForm.fileId;
          }

          let param = {
            deviceType: this.dialogForm.deviceType || "android:device_type",
            isForce: this.dialogForm.isForce || 0,
            number: this.dialogForm.number,
            versionName: this.dialogForm.versionName,
            remark: this.dialogForm.remark,
            fileId: fileIds,
          };
          if (this.dialogType == "add") {
            this.$API.addAppVersion(param).then((res) => {
              this.getData();
              this.isShowDialog = false;
              this.$message.success(res.data.message || "新建成功");
            });
          }

          if (this.dialogType == "edit") {
            param.versionId = this.dialogForm.versionId;
            this.$API.udpateAppVersion(param).then((res) => {
              this.getData();
              this.isShowDialog = false;
              this.$message.success(res.data.message || "修改成功");
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    // diaCancelBtn() {
    //   this.isShowDialog = false;
    // },

    /***
     * ====== 弹窗组件方法 ======
     */
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}

.clickDownLoad {
  cursor: pointer;
}
</style>
